import React from "react";
import { IMachine as Machine } from "../../../interfaces";
import BtnEditTask from "./BtnEditTask";
import BtnMarkAsImportant from "./BtnMarkAsImportant";
import BtnDeleteTask from "./BtnDeleteTask";
import BtnToggleCompleted from "./BtnToggleActive";

const ActionsTaskItem: React.FC<{
  machine: Machine;
  isListInView1: boolean;
}> = ({ machine, isListInView1 }) => {
  return (
    <>
      <div
        className={`flex  border-dashed border-slate-700 dark:border-slate-700/[.3] ${
          isListInView1 ? "items-center" : " border-t-2 w-full pt-4 mt-4"
        }`}
      >
        {/* <BtnMarkAsImportant machineId={machine.id} taskImportant={machine.important} /> */}

        <div className="grow ">
          {/* <BtnToggleCompleted
            machineActive={machine.active}
            machineId={machine.id}
            isListInView1={isListInView1}
          /> */}
        </div>
        <div className=" float-right">
          <BtnDeleteTask machineId={machine.id} email={machine.Email} />
        </div>
      
      </div>
    </>
  );
};

export default ActionsTaskItem;
